import { createSlice } from '@reduxjs/toolkit';
import type { LoginData } from '../../api/responses';
import { performLogin } from './authSlice';
import { logout } from './authSlice';

interface StoreState {
  storeInfo: LoginData | null;
}

const initialState: StoreState = {
  storeInfo: null,
};

const storeSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 로그인 성공(code === 0) 시 매장 정보 저장
    builder.addCase(performLogin.fulfilled, (state, action) => {
      state.storeInfo = action.payload.data;
    });

    // 로그인 실패 또는 로그아웃 시 매장 정보 초기화
    builder.addCase(performLogin.rejected, (state) => {
      state.storeInfo = null;
    });
    builder.addCase(logout, (state) => {
      state.storeInfo = null;
    });
  },
});

export default storeSlice.reducer;
